export const STATUS = {
  REVISING_SUBMISSION: 'revising submission',
  PASSED_TAKE_HOME_CHALLENGE: 'passed take home challenge',
  PRE_SCREEN_INTERVIEW: 'pre-screen interview',
  TECHNICAL_INTERVIEW: 'technical interview',
  JF_TECHNICAL_INTERVIEW: 'JF: ti',
  NEGOTIATION: 'negotiation',
  JF_NEGOTIATION: 'JF: negotiation',
  STANDARDIZED_RESUME: 'standardized resume',
  READY: 'ready',
  MATCHED_INTERNAL: 'matched internal',
  MATCHED_CUSTOMER: 'matched customer',
  FAILED: 'failed',
  FIRED: 'fired',
  READY_2_0: 'ready 2.0',
  ELIGIBLE_SUPPLY: 'eligible supply',
  ADDITIONAL_MCQ: 'additional mcq',
  SCHEDULING_TECH_INTERVIEW: 'scheduling tech interview',
  JF_SCHEDULING_TECH_INTERVIEW: 'JF: scheduling ti',
  SCHEDULING_NEGOTIATION: 'scheduling negotiation',
  JF_SCHEDULING_NEGOTIATION: 'JF: scheduling negotiation',
  UNRESPONSIVE: 'unresponsive',
  READY_2_0_PARTTIME: 'ready 2.0 parttime',
  INTERVIEW_ELIGIBLE: 'interview eligible',
  ATTEMPTED_1ST_MCQ: 'attempted 1st mcq',
  INTERNAL_USER: 'internal user',
  IN_TRIAL: 'in trial',
  RESUME_REVIEW: 'resume review',
  SIGN_UP: 'sign up',
  UPLOADED_RESUME: 'uploaded resume',
  SIGNUP_COMPLETED: 'signup completed',
  ATTEMPTED_ALGO_CHALLENGE: 'attempted algo challenge',
  PASSED_ALGO_CHALLENGE: 'passed algo challenge',
  FAILED_ALGO_CHALLENGE: 'failed algo challenge',
  EXPERIENCE_INELIGIBLE: 'deprecated - experience ineligible',
  FUTURE_OPPORTUNITY: 'future opportunity',
  OFAC_INVESTIGATION: 'ofac investigation',
  OFAC_RESTRICTED: 'ofac restricted',
  PASSED_TI: 'passed ti',
  PRE_SCREENING: 'pre-screening',
  SCHEDULING_PRE_SCREENING: 'scheduling pre-screening',
  COMPLETED_PROFILE: 'completed profile',
  ATTEMPTED_WORKEXP: 'attempted work experience mcq',
  INELIGIBLE: 'ineligible',
  AVAILABLE_SUPPLY: 'available supply',
  STARTED_ASA: 'started ASA',
  PASSED_VETTING: 'passed vetting',
  PASSED_CODING_CHALLENGE: 'passed coding challenge',
  // STARTED_ASA: 'started ASA',
  COMPLETED_ASA: 'completed ASA',
  STARTED_1ST_MCQ: 'Started 1st Tech MCQ',
  PASSED_1ST_MCQ: 'Passed 1st Tech MCQ',
  PASSED_TECH_STACK: 'Passed tech stack',
  STARTED_ACC: 'Started ACC',
  FAILED_ACC: 'Failed ACC',
  PASSED_SEMI_VETTING: 'passed semi-vetting',
  SEMI_VETTED_STANDARDIZED_RESUME: 'Semi-vetted: Standardized Resume',
  SEMI_VETTED_AVAILABLE_SUPPLY: 'Semi-vetted: Available Supply',
  RECORDED_SOFT_SKILLS: 'recorded soft skills'
};

export const STATUS_RANK = {

  [STATUS.UNRESPONSIVE]: 0,
  [STATUS.FAILED]: 0,

  [STATUS.SIGN_UP]: 10,

  [STATUS.UPLOADED_RESUME]: 20,

  [STATUS.SIGNUP_COMPLETED]: 25,

  [STATUS.ATTEMPTED_ALGO_CHALLENGE]: 30,

  [STATUS.PASSED_ALGO_CHALLENGE]: 40,
  [STATUS.FAILED_ALGO_CHALLENGE]: 40,
  [STATUS.PASSED_TAKE_HOME_CHALLENGE]: 40,

  [STATUS.STARTED_ASA]: 47,
  [STATUS.COMPLETED_ASA]: 48,

  [STATUS.STARTED_1ST_MCQ]: 49,

  [STATUS.ATTEMPTED_WORKEXP]: 50,
  [STATUS.ATTEMPTED_1ST_MCQ]: 50,

  [STATUS.PASSED_1ST_MCQ]: 60,
  [STATUS.ADDITIONAL_MCQ]: 60,
  [STATUS.INTERVIEW_ELIGIBLE]: 60,

  [STATUS.PASSED_SEMI_VETTING]: 61,
  [STATUS.SEMI_VETTED_AVAILABLE_SUPPLY]: 61,
  [STATUS.SEMI_VETTED_STANDARDIZED_RESUME]: 61,

  [STATUS.PASSED_TECH_STACK]: 62,

  [STATUS.SCHEDULING_TECH_INTERVIEW]: 70,
  [STATUS.JF_SCHEDULING_TECH_INTERVIEW]: 70,

  [STATUS.TECHNICAL_INTERVIEW]: 80,
  [STATUS.JF_TECHNICAL_INTERVIEW]: 80,

  [STATUS.STARTED_ACC]: 84,
  [STATUS.FAILED_ACC]: 85,
  [STATUS.PASSED_CODING_CHALLENGE]: 86,

  [STATUS.PASSED_TI]: 90,
  [STATUS.PASSED_VETTING]: 90,

  [STATUS.RECORDED_SOFT_SKILLS]: 95,

  [STATUS.SCHEDULING_PRE_SCREENING]: 100,

  [STATUS.PRE_SCREEN_INTERVIEW]: 110,
  [STATUS.PRE_SCREENING]: 110,

  [STATUS.SCHEDULING_NEGOTIATION]: 120,
  [STATUS.JF_SCHEDULING_NEGOTIATION]: 120,

  [STATUS.NEGOTIATION]: 130,
  [STATUS.JF_NEGOTIATION]: 130,

  [STATUS.STANDARDIZED_RESUME]: 140,
  [STATUS.RESUME_REVIEW]: 140,
  [STATUS.COMPLETED_PROFILE]: 140,

  [STATUS.REVISING_SUBMISSION]: 150,
  [STATUS.ELIGIBLE_SUPPLY]: 150,
  [STATUS.FUTURE_OPPORTUNITY]: 150,

  [STATUS.READY]: 160,
  [STATUS.READY_2_0_PARTTIME]: 160,
  [STATUS.READY_2_0]: 160,
  [STATUS.AVAILABLE_SUPPLY]: 160,

  [STATUS.IN_TRIAL]: 170,
  [STATUS.MATCHED_INTERNAL]: 170,
  [STATUS.MATCHED_CUSTOMER]: 170,
  [STATUS.INTERNAL_USER]: 170,

  [STATUS.OFAC_INVESTIGATION]: 180,
  [STATUS.OFAC_RESTRICTED]: 180,
  [STATUS.INELIGIBLE]: 190,
  [STATUS.FIRED]: 200
};

/* GLUED STATUSSES MEAN THE STATUS CANNOT BE CHANGED TO ANYTHING ELSE */
const GLUED_STATUSSES = [
  STATUS.FIRED,
  STATUS.INELIGIBLE,
  STATUS.OFAC_RESTRICTED,
  STATUS.OFAC_INVESTIGATION,
  STATUS.REVISING_SUBMISSION,
  STATUS.FUTURE_OPPORTUNITY
];

/* NOT VETTING STATUSSES MEAN THE STATUS SHOULDN'T BE CHANGED TO ANYTHING BY VETTING */
export const NOT_VETTING_STATUSSES = [
  STATUS.STANDARDIZED_RESUME,
  STATUS.RESUME_REVIEW,
  STATUS.COMPLETED_PROFILE,

  STATUS.REVISING_SUBMISSION,
  STATUS.ELIGIBLE_SUPPLY,
  STATUS.FUTURE_OPPORTUNITY,

  STATUS.READY,
  STATUS.READY_2_0_PARTTIME,
  STATUS.READY_2_0,
  STATUS.AVAILABLE_SUPPLY,

  STATUS.IN_TRIAL,
  STATUS.MATCHED_INTERNAL,
  STATUS.MATCHED_CUSTOMER,
  STATUS.INTERNAL_USER
];

export const IS_VETTING_USEABLE = (status) => {
  // return !(GLUED_STATUSSES.includes(status) || NOT_VETTING_STATUSSES.includes(status));
  return !GLUED_STATUSSES.includes(status);
};

export const COMPARE_STATUS = (a, b) => {
  /* < 0: a LOWER RANK, = 0: SAME RANK, > 0: a HIGHER RANK */
  const rankA = STATUS_RANK[a] || -1;
  const rankB = STATUS_RANK[b] || -1;
  return rankA - rankB;
};
